export const SET_CHANNELS = "SET_CHANNELS";
export const SET_CHANNELS_ERROR = "SET_CHANNELS_ERROR";
export const CLEAR_CHANNELS_ERROR = "CLEAR_CHANNELS_ERROR";
